(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["countdown-timer"] && !Shopify.designMode) return;
  try {
    // Counts down to midnight in the visitor's own timezone and rolls straight
  // into the next day. Derived from the clock each tick, so there is nothing
  // stored and nothing to fall back to: reloading, or crossing midnight with
  // the page open, both land on the correct value.
  (() => {
    const start = () => {
      const el = document.getElementById('countdown-display');
      if (!el) return;

      const pad = (n) => String(n).padStart(2, '0');

      const tick = () => {
        const now = new Date();
        const midnight = new Date(now);
        midnight.setHours(24, 0, 0, 0); // 24:00 today === 00:00 tomorrow, local

        const left = Math.max(0, Math.floor((midnight - now) / 1000));
        const h = Math.floor(left / 3600);
        const m = Math.floor((left % 3600) / 60);
        const s = left % 60;
        el.textContent = `${pad(h)}:${pad(m)}:${pad(s)}`;
      };

      tick();
      setInterval(tick, 1000);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["popup-button"] && !Shopify.designMode) return;
  try {
    (function() {
    const triggers = document.querySelectorAll('[data-popup-trigger]');
    
    triggers.forEach(trigger => {
      const popupId = trigger.getAttribute('data-popup-trigger');
      const modal = document.querySelector(`[data-popup-modal="${popupId}"]`);
      const closeButtons = modal ? modal.querySelectorAll(`[data-popup-close="${popupId}"]`) : [];
      const tabs = modal ? modal.querySelectorAll(`[data-tab][data-popup-id="${popupId}"]`) : [];
      const panels = modal ? modal.querySelectorAll(`[data-panel][data-popup-id="${popupId}"]`) : [];

      if (!modal) return;

      trigger.addEventListener('click', () => {
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });

      closeButtons.forEach(btn => {
        btn.addEventListener('click', () => {
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        });
      });

      modal.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          modal.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      });

      tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const tabNum = tab.getAttribute('data-tab');
          
          tabs.forEach(t => t.classList.remove('popup-modal__tab--active'));
          tab.classList.add('popup-modal__tab--active');
          
          panels.forEach(panel => {
            if (panel.getAttribute('data-panel') === tabNum) {
              panel.classList.add('popup-modal__panel--active');
            } else {
              panel.classList.remove('popup-modal__panel--active');
            }
          });
        });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-accordion"] && !Shopify.designMode) return;
  try {
    // Opens the ingredient popup with a native <dialog>: modal behaviour, Esc to
  // close and focus handling come for free, no library needed.
  (() => {
    if (window.__accordionPopupBound) return;
    window.__accordionPopupBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.accordion-popup-trigger[aria-haspopup="dialog"]');
      if (trigger) {
        const id = trigger.getAttribute('data-popup-trigger');
        const dialog = document.querySelector(`.accordion-popup[data-popup="${id}"]`);
        if (dialog) {
          event.preventDefault();
          if (typeof dialog.showModal === 'function') dialog.showModal();
          else dialog.setAttribute('open', '');
        }
        return;
      }

      if (event.target.closest('[data-popup-close]')) {
        const dialog = event.target.closest('.accordion-popup');
        if (dialog) dialog.close ? dialog.close() : dialog.removeAttribute('open');
        return;
      }

      // Click outside the panel closes it.
      const openDialog = event.target.classList?.contains('accordion-popup') ? event.target : null;
      if (openDialog) openDialog.close ? openDialog.close() : openDialog.removeAttribute('open');
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["quantity-break"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('quantity-break')) {
    customElements.define(
      'quantity-break',
      class QuantityBreak extends HTMLElement {
        connectedCallback() {
          this.inputs = this.querySelectorAll('.qb__input');
          this.hiddenQty = this.querySelector('.quantity-preset-input');
          this.syncQuantity();
          this.inputs.forEach((input) => {
            input.addEventListener('change', () => this.onChange(input));
          });
          this.bindForm();
          this.unitPrice = Number(this.dataset.unitPrice || 0);
          this.unitCompare = Number(this.dataset.unitCompare || 0);
          this.giftTotal = Number(this.dataset.giftTotal || 0);
          // Only foreign-currency shoppers need a repaint; at rate 1 nothing changes.
          // window.Shopify.currency is populated AFTER this element upgrades, so the rate
          // is re-checked on a later tick rather than trusted on the first read.
          {
            const repaintIfConverted = () => {
              if (this.presentmentRate !== 1) this.paintTierPrices();
            };
            requestAnimationFrame(repaintIfConverted);
            setTimeout(repaintIfConverted, 500);
          }
          document.addEventListener('variant:update', this.onVariantUpdate);
          requestAnimationFrame(() => this.updateMainPrice());
        }

        disconnectedCallback() {
          document.removeEventListener('variant:update', this.onVariantUpdate);
          if (this.form && this.submitHandler) {
            this.form.removeEventListener('submit', this.submitHandler, true);
          }
        }

        get selectedInput() {
          return this.querySelector('.qb__input:checked');
        }

        get isBundle() {
          return this.selectedInput?.value === 'bundle';
        }

        onChange(input) {
          this.querySelectorAll('.qb__bar').forEach((bar) => {
            bar.classList.toggle('is-selected', bar.contains(input) && input.checked);
          });
          this.syncQuantity();
          this.updateMainPrice();
        }

        syncQuantity() {
          const qty = Number(this.selectedInput?.dataset.quantity || 1);
          if (this.hiddenQty) this.hiddenQty.value = String(qty);
          const form = this.getForm();
          if (!form) return;
          // The theme adds the MAIN product itself from the form's quantity field.
          // Make sure exactly one quantity input exists INSIDE the form and carries
          // the selected quantity, so the bundle option adds 2 (not the default 1).
          let qtyFields = form.querySelectorAll('input[name="quantity"]');
          if (!qtyFields.length) {
            const hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'quantity';
            form.appendChild(hidden);
            qtyFields = form.querySelectorAll('input[name="quantity"]');
          }
          qtyFields.forEach((field) => {
            field.value = String(qty);
          });
          const selector = form.querySelector('quantity-selector-component input, .quantity-input, input.quantity__input');
          if (selector) selector.value = String(qty);
        }

        getForm() {
          const section = this.closest('.shopify-section');
          return (
            section?.querySelector('product-form-component form') ||
            document.querySelector('product-form-component form[action*="/cart/add"]')
          );
        }

        bindForm() {
          this.form = this.getForm();
          if (!this.form) return;
          this.submitHandler = (event) => this.onSubmit(event);
          this.form.addEventListener('submit', this.submitHandler, true);
          this.syncQuantity();
        }

        // pilot-cart-bundle-v1: product-form owns the only add request.
        onSubmit() { this.syncQuantity(); }

        buildCartAddPayload(formData, sectionIds) {
          const id = Number(this.dataset.variantId);
          const quantity = Number(this.selectedInput?.dataset.quantity || 1);
          if (!Number.isSafeInteger(id) || id <= 0 || !Number.isSafeInteger(quantity) || quantity < 1) {
            throw new Error('Invalid main product or quantity');
          }
          const properties = {};
          for (const [key, value] of formData.entries()) {
            const match = key.match(/^properties\[(.+)\]$/);
            if (match) {
              if (typeof value !== 'string') throw new Error('File properties require the original product form');
              properties[match[1]] = value;
            }
          }
          formData.set('id', String(id));
          formData.set('quantity', String(quantity));
          const main = { id, quantity, properties };
          const sellingPlan = formData.get('selling_plan');
          if (sellingPlan) main.selling_plan = sellingPlan;
          const gifts = this.isBundle ? JSON.parse(this.dataset.giftVariantIds || '[]') : [];
          if (!Array.isArray(gifts) || gifts.some(g => !Number.isSafeInteger(Number(g)) || Number(g) <= 0)) throw new Error('Invalid gift configuration');
          const items = [main, ...[...new Set(gifts.map(Number))].filter(g => g !== id).map(g => ({
            id: g, quantity: 1, properties: { _quantity_break_gift: 'true' }
          }))];
          return { items, ...(sectionIds.length ? {sections: sectionIds.join(','), sections_url: window.location.pathname} : {}) };
        }

        onVariantUpdate = (event) => {
          const variant = event.detail?.resource;
          const productId = String(event.detail?.data?.productId || '');
          if (!variant || !productId || productId !== String(this.dataset.productId)) return;

          this.dataset.variantId = String(variant.id);
          const unitPrice = this.toCents(variant.price);
          let unitCompare = this.toCents(variant.compare_at_price);
          if (!unitCompare || unitCompare <= unitPrice) unitCompare = unitPrice;
          this.unitPrice = unitPrice;
          this.unitCompare = unitCompare;

          const qty = Number(this.dataset.qtyBundle || 2);
          const percent = Number(this.dataset.discountPercent || 0);
          const fixedBundle = this.fixedBundleCents();
          let bundlePrice = unitPrice * qty;
          if (fixedBundle > 0) {
            bundlePrice = fixedBundle;
          } else if (percent > 0) {
            bundlePrice = Math.round((bundlePrice * (100 - percent)) / 100);
          }
          const bundleCompare = unitCompare * qty;
          const save = bundleCompare - bundlePrice;

          this.writePrice('[data-qb-price="classic"]', unitPrice);
          this.writeCompare('[data-qb-compare="classic"]', unitCompare, unitPrice);
          this.writePrice('[data-qb-price="bundle"]', bundlePrice);
          this.writeCompare('[data-qb-compare="bundle"]', bundleCompare, bundlePrice);

          const saveEl = this.querySelector('[data-qb-save]');
          if (saveEl) {
            if (save > 0) {
              saveEl.hidden = false;
              saveEl.textContent = (this.dataset.saveTemplate || 'SAVE [amount]').replace(
                '[amount]',
                this.formatMoney(save)
              );
            } else {
              saveEl.hidden = true;
            }
          }

          // Shopify's <product-price> also re-renders on variant:update; defer so we win.
          requestAnimationFrame(() => this.updateMainPrice());
        };

        get mainPriceEls() {
          const scope = this.closest('.shopify-section') || document;
          const pp = scope.querySelector('product-price');
          if (!pp) return null;
          return {
            price: pp.querySelector('.price'),
            compare: pp.querySelector('.compare-at-price'),
          };
        }

        // Total shown on top of the page for the currently selected option.
        // compare = (unit compare-at x quantity) + value of all free gifts.
        selectedTotals() {
          if (!this.isBundle) {
            return {
              price: this.unitPrice,
              compare: this.unitCompare > this.unitPrice ? this.unitCompare : 0,
            };
          }
          const qty = Number(this.dataset.qtyBundle || 2);
          const percent = Number(this.dataset.discountPercent || 0);
          const fixed = this.fixedBundleCents();
          let price = this.unitPrice * qty;
          if (fixed > 0) {
            price = fixed;
          } else if (percent > 0) {
            price = Math.round((price * (100 - percent)) / 100);
          }
          const compare = this.unitCompare * qty + this.giftTotal;
          return { price, compare };
        }

        updateMainPrice() {
          const els = this.mainPriceEls;
          if (!els || !els.price) return;
          const { price, compare } = this.selectedTotals();
          els.price.textContent = this.formatMoney(price);
          if (els.compare) {
            const group = els.compare.closest('[role="group"]') || els.compare;
            if (compare > price) {
              els.compare.textContent = this.formatMoney(compare);
              group.style.removeProperty('display');
            } else {
              group.style.display = 'none';
            }
          }
        }

        writePrice(selector, cents) {
          const el = this.querySelector(selector);
          if (el) el.textContent = this.formatMoney(cents);
        }

        writeCompare(selector, compareCents, priceCents) {
          const el = this.querySelector(selector);
          if (!el) return;
          if (compareCents > priceCents) {
            el.hidden = false;
            el.textContent = this.formatMoney(compareCents);
          } else {
            el.hidden = true;
          }
        }

        /* The bundle price is configured in the SHOP's currency, but a shopper in another
           market is billed in theirs. Without converting, the page would advertise "39 Ft"
           while the discount function charges the real converted price. */
        get presentmentRate() {
          const rate = Number(window.Shopify?.currency?.rate);
          return Number.isFinite(rate) && rate > 0 ? rate : 1;
        }

        /* An exact price for one market, e.g. {"CHF": 39}, so a converted price does not
           land on an awkward figure. Must mirror pricesByCurrency in the discount settings,
           or the page and the checkout would disagree. */
        currencyOverrideCents() {
          const raw = this.dataset.pricesByCurrency;
          if (!raw) return 0;
          const code = window.Shopify?.currency?.active;
          if (!code) return 0;
          try {
            const map = JSON.parse(raw);
            if (!map || typeof map !== 'object') return 0;
            const value = Number(map[code] ?? map[code.toUpperCase()]);
            return Number.isFinite(value) && value > 0 ? Math.round(value * 100) : 0;
          } catch {
            return 0; // a typo in the setting must never break the page
          }
        }

        fixedBundleCents() {
          const override = this.currencyOverrideCents();
          if (override > 0) return override;
          const raw = Number(this.dataset.fixedBundle || 0);
          if (!(raw > 0)) return 0;
          return Math.round(raw * this.presentmentRate);
        }

        /* Repaints the tier prices from the values already on the element. Used on load so a
           foreign-currency shopper never sees the unconverted server-rendered price. */
        paintTierPrices() {
          const unitPrice = Number(this.unitPrice || 0);
          if (!(unitPrice > 0)) return;
          let unitCompare = Number(this.unitCompare || 0);
          if (!unitCompare || unitCompare <= unitPrice) unitCompare = unitPrice;

          const qty = Number(this.dataset.qtyBundle || 2);
          const percent = Number(this.dataset.discountPercent || 0);
          const fixedBundle = this.fixedBundleCents();
          let bundlePrice = unitPrice * qty;
          if (fixedBundle > 0) {
            bundlePrice = fixedBundle;
          } else if (percent > 0) {
            bundlePrice = Math.round((bundlePrice * (100 - percent)) / 100);
          }
          const bundleCompare = unitCompare * qty;

          this.writePrice('[data-qb-price="classic"]', unitPrice);
          this.writeCompare('[data-qb-compare="classic"]', unitCompare, unitPrice);
          this.writePrice('[data-qb-price="bundle"]', bundlePrice);
          this.writeCompare('[data-qb-compare="bundle"]', bundleCompare, bundlePrice);

          const saveEl = this.querySelector('[data-qb-save]');
          if (saveEl) {
            const save = bundleCompare - bundlePrice;
            if (save > 0) {
              saveEl.hidden = false;
              saveEl.textContent = (this.dataset.saveTemplate || 'SAVE [amount]').replace(
                '[amount]',
                this.formatMoney(save)
              );
            } else {
              saveEl.hidden = true;
            }
          }
          this.updateMainPrice();
        }

        toCents(value) {
          if (value == null || value === '') return 0;
          if (typeof value === 'number') return Math.round(value);
          const raw = String(value).trim();
          if (raw.includes('.') || raw.includes(',')) {
            return Math.round(parseFloat(raw.replace(',', '.').replace(/[^\d.]/g, '')) * 100) || 0;
          }
          return parseInt(raw.replace(/\D/g, ''), 10) || 0;
        }

        formatMoney(cents) {
          let formatted;
          if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
            formatted = window.Shopify.formatMoney(cents, this.dataset.moneyFormat);
          } else {
            formatted = this.renderMoneyFormat(cents, this.dataset.moneyFormat);
          }
          if (this.dataset.hideZeros === 'true') {
            formatted = formatted.replace(/([.,]00)\b/g, '');
          }
          return formatted;
        }

        // Fallback money renderer for themes that don't expose Shopify.formatMoney.
        // Understands the standard {{amount*}} placeholders so the currency symbol is kept.
        renderMoneyFormat(cents, format) {
          format = format || '${{amount}}';
          const build = (precision, thousands, decimal) => {
            const num = (Math.round(cents) / 100).toFixed(precision);
            let [int, dec] = num.split('.');
            int = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
            return dec ? int + decimal + dec : int;
          };
          return format.replace(/\{\{\s*(\w+)\s*\}\}/g, (match, name) => {
            switch (name) {
              case 'amount': return build(2, ',', '.');
              case 'amount_with_comma_separator': return build(2, '.', ',');
              case 'amount_with_space_separator': return build(2, ' ', ',');
              case 'amount_no_decimals': return build(0, ',', '.');
              case 'amount_no_decimals_with_comma_separator': return build(0, '.', ',');
              case 'amount_no_decimals_with_space_separator': return build(0, ' ', ',');
              default: return build(2, ',', '.');
            }
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
